(() => {
  // Bind once per page, even if the snippet or script is rendered twice.
  if (window.thbCookiePreferencesBound) return;
  window.thbCookiePreferencesBound = true;

  const TRIGGER = '[data-cookie-preferences-trigger]';
  const LOAD_TIMEOUT = 5000;
  const ERROR_MESSAGE = "Cookie preferences couldn't be opened. Please refresh the page and try again.";

  // storefront-banner.js is injected async by Shopify and defines window.privacyBanner.
  const getPrivacyBanner = () => {
    const banner = window.privacyBanner;
    return banner && typeof banner.showPreferences === 'function' ? banner : null;
  };

  const waitForPrivacyBanner = () => new Promise((resolve, reject) => {
    const banner = getPrivacyBanner();
    if (banner) return resolve(banner);

    const started = Date.now();
    const timer = setInterval(() => {
      const loaded = getPrivacyBanner();
      if (loaded) {
        clearInterval(timer);
        resolve(loaded);
      } else if (Date.now() - started > LOAD_TIMEOUT) {
        clearInterval(timer);
        reject(new Error('window.privacyBanner.showPreferences is not available'));
      }
    }, 100);
  });

  const setStatus = (button, message) => {
    const status = button.parentElement.querySelector('[data-cookie-preferences-status]');
    if (status) status.textContent = message;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(TRIGGER);
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    button.setAttribute('aria-busy', 'true');
    setStatus(button, '');

    waitForPrivacyBanner()
      .then((banner) => banner.showPreferences())
      .catch((error) => {
        console.error('[Cookie preferences]', error);
        setStatus(button, ERROR_MESSAGE);
      })
      .finally(() => button.removeAttribute('aria-busy'));
  });
})();
